import { APIClient } from '@autopylot-internal/autopylot-api-client';

type ISO8601 = string;

export interface IExperimentConfig {
    startsAt: ISO8601;
    endsAt: ISO8601; // sort key (get me those that haven't ended yet)
    endsAtUserCount: number;
    enablesFlags: string[]; // eg preMissionWeather
    targetUsers: string[]; // userids
}

export class AdminCommands {

    static inject = () => [APIClient];
    constructor(private apiClient: APIClient) {}

    switchTiles = async (name: string) => {

        try {
            await this.apiClient.post('/admin/commands', {
                command: 'tiles:switch-to-names-tiles',
                name
            });

            console.log(`Request to switch tiles to "${name}" has been successfully queued`);

        } catch (e: any) {
            console.error(`Failed to switch tiles to "${name}": ${e.message}`);
        }
    };

    addExperiment = async (experiment: IExperimentConfig) => {
        try {
            await this.apiClient.post('/admin/commands', {
                command: 'experiments:add',
                ...experiment
            });

            console.log(`Experiment created`);

        } catch (e: any) {
            console.error(`Failed to add experiment: ${e.message}`);
        }
    };

    getMissingTFRsReport = async () => {
        try {
            const { csv } = await this.apiClient.post('/admin/commands', {
                command: 'MissingTFRsCommands:get-missing-tfrs'
            });

            const blob = new Blob([csv], { type: 'text/plain' });

            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = `missing-tfrs-${new Date().toISOString()}.csv`;

            a.click();

        } catch (e: any) {
            console.error(`Failed: ${e.message}`);
        }
    };

    updateMissingTFR = async ({ tfr, foundAt, notes }: { tfr: string; foundAt?: ISO8601; notes?: string; }) => {
        try {
            await this.apiClient.post('/admin/commands', {
                command: 'MissingTFRsCommands:update-missing-tfr',
                tfr,
                foundAt,
                notes
            });
            console.log('success');

        } catch (e: any) {
            console.error(`Failed: ${e.message}`);
        }
    };
}
